import React from 'react'
import { useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import { VrEndSchema, initialVrEndValues } from '../../utils/validation/vr.js'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'
import { useRecordLock } from '../../contexts/RecordLockContext'
import useVR from '../../hooks/useVR'

import ActionBar from '../shared/ActionBar.js'

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const VrEnd = () => {
  const { id } = useParams()
  const { sideNavOpen } = useSideNav(true)
  const { recordLock, setRecordLock } = useRecordLock()
  const { getVRDraft, patchVRDraft } = useVR({ id })

  const handleSave = (values, { setSubmitting }) => {
    patchVRDraft.mutate(values)
    setSubmitting(false)
    setRecordLock(true)
  }

  const handleChange = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    setValues({ ...values, [name]: value })
  }
  const addTime = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    values = { ...values, [name]: value }

    let n1 = parseInt(values.timeIntake) || 0
    let n2 = parseInt(values.timeWp) || 0
    let n3 = parseInt(values.timePwdDryer) || 0
    let n4 = parseInt(values.timeMpcDryer) || 0
    let n5 = parseInt(values.timePwdPkg) || 0
    let n6 = parseInt(values.timeMpcPkg) || 0
    let n7 = parseInt(values.timeButter) || 0
    let n8 = parseInt(values.timeDocumentation) || 0
    let n9 = parseInt(values.timeAdditional) || 0

    values.timeTotal = n1 + n2 + n3 + n4 + n5 + n6 + n7 + n8 + n9

    setValues(values)
  }

  const handleDateChange = (name, value, values, setValues) => {
    setValues({ ...values, [name]: value })
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialVrEndValues,
          ...getVRDraft?.data,
        }}
        validationSchema={VrEndSchema}
        onSubmit={(values, { setSubmitting }) =>
          handleSave(values, { setSubmitting })
        }
        enableReinitialize
      >
        {({
          isSubmitting,
          handleSubmit,
          values,
          touched,
          errors,
          setValues,
        }) => (
          <>
            <Form id={`vr${id}`} onSubmit={handleSubmit}>
              <Grid
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                  pl: sideNavOpen ? '260px' : '60px',
                  pt: '70px',
                  pr: '10px',
                  pb: '100px',
                }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography variant='h1'>
                    Vacation Relief End Shift Passdown
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='name'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.name}
                    error={touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Date Shift Started
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DatePicker
                    name='date'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('date', value, values, setValues)
                    }
                    value={values.date}
                    error={touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='shift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.shift}
                    error={touched.shift && !!errors.shift}
                    helperText={touched.shift && errors.shift}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='A Day'>A Day</MenuItem>
                    <MenuItem value='A Night'>A Night</MenuItem>
                    <MenuItem value='B Day'>B Day</MenuItem>
                    <MenuItem value='B Night'>B Night</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Message From Sender
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='message'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.message}
                    error={touched.message && !!errors.message}
                    helperText={touched.message && errors.message}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    PASSDOWN
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>

                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Area
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6'>Time (Hrs)</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant='h6'>Description</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Intake
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeIntake'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeIntake}
                    error={touched.timeIntake && !!errors.timeIntake}
                    helperText={touched.timeIntake && errors.timeIntake}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Intake Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeIntakeDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeIntakeDescription}
                    error={
                      touched.timeIntakeDescription &&
                      !!errors.timeIntakeDescription
                    }
                    helperText={
                      touched.timeIntakeDescription &&
                      errors.timeIntakeDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Wet Processing
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeWp'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeWp}
                    error={touched.timeWp && !!errors.timeWp}
                    helperText={touched.timeWp && errors.timeWp}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Wet Processing Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeWpDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeWpDescription}
                    error={
                      touched.timeWpDescription && !!errors.timeWpDescription
                    }
                    helperText={
                      touched.timeWpDescription && errors.timeWpDescription
                    }
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Powder Evap/Dryer
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timePwdDryer'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timePwdDryer}
                    error={touched.timePwdDryer && !!errors.timePwdDryer}
                    helperText={touched.timePwdDryer && errors.timePwdDryer}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pwd Evap/Dryer Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timePwdDryerDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timePwdDryerDescription}
                    error={
                      touched.timePwdDryerDescription &&
                      !!errors.timePwdDryerDescription
                    }
                    helperText={
                      touched.timePwdDryerDescription &&
                      errors.timePwdDryerDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    MPC Dryer
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeMpcDryer'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeMpcDryer}
                    error={touched.timeMpcDryer && !!errors.timeMpcDryer}
                    helperText={touched.timeMpcDryer && errors.timeMpcDryer}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    MPC Dryer Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeMpcDryerDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeMpcDryerDescription}
                    error={
                      touched.timeMpcDryerDescription &&
                      !!errors.timeMpcDryerDescription
                    }
                    helperText={
                      touched.timeMpcDryerDescription &&
                      errors.timeMpcDryerDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Powder Packaging
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timePwdPkg'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timePwdPkg}
                    error={touched.timePwdPkg && !!errors.timePwdPkg}
                    helperText={touched.timePwdPkg && errors.timePwdPkg}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pwd Pkg Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timePwdPkgDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timePwdPkgDescription}
                    error={
                      touched.timePwdPkgDescription &&
                      !!errors.timePwdPkgDescription
                    }
                    helperText={
                      touched.timePwdPkgDescription &&
                      errors.timePwdPkgDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    MPC Packaging
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeMpcPkg'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeMpcPkg}
                    error={touched.timeMpcPkg && !!errors.timeMpcPkg}
                    helperText={touched.timeMpcPkg && errors.timeMpcPkg}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    MPC Pkg Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeMpcPkgDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeMpcPkgDescription}
                    error={
                      touched.timeMpcPkgDescription &&
                      !!errors.timeMpcPkgDescription
                    }
                    helperText={
                      touched.timeMpcPkgDescription &&
                      errors.timeMpcPkgDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Butter
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeButter'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeButter}
                    error={touched.timeButter && !!errors.timeButter}
                    helperText={touched.timeButter && errors.timeButter}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Butter Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeButterDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeButterDescription}
                    error={
                      touched.timeButterDescription &&
                      !!errors.timeButterDescription
                    }
                    helperText={
                      touched.timeButterDescription &&
                      errors.timeButterDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Documentation
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeDocumentation'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeDocumentation}
                    error={
                      touched.timeDocumentation && !!errors.timeDocumentation
                    }
                    helperText={
                      touched.timeDocumentation && errors.timeDocumentation
                    }
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Documentation Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeDocumentationDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeDocumentationDescription}
                    error={
                      touched.timeDocumentationDescription &&
                      !!errors.timeDocumentationDescription
                    }
                    helperText={
                      touched.timeDocumentationDescription &&
                      errors.timeDocumentationDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Additional
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeAdditional'
                    disabled={recordLock}
                    type='number'
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeAdditional}
                    error={touched.timeAdditional && !!errors.timeAdditional}
                    helperText={touched.timeAdditional && errors.timeAdditional}
                  />
                </Grid>
                <Grid item xs={3} display={{ xs: 'block', sm: 'none' }}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Additional Description
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeAdditionalDescription'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.timeAdditionalDescription}
                    error={
                      touched.timeAdditionalDescription &&
                      !!errors.timeAdditionalDescription
                    }
                    helperText={
                      touched.timeAdditionalDescription &&
                      errors.timeAdditionalDescription
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total Time
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='timeTotal'
                    disabled={true}
                    onChange={(e) => addTime(e, values, setValues)}
                    value={values.timeTotal}
                    error={touched.timeTotal && !!errors.timeTotal}
                    helperText={touched.timeTotal && errors.timeTotal}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
              </Grid>
              <ActionBar
                id={id}
                editOnly={true}
                values={values}
                setValues={setValues}
                record='vr'
                newToolTip='New VR Passdown'
              />
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default VrEnd
